import React, { MouseEvent } from "react";
interface StarProps {
  index: number;
  size: number;
  filledColor: string;
  emptyColor: string;
  innerRadius: number;
  outerRadius: number;
  handleStarMouseMove: (e: number, index: number) => void;
  handleMouseOut: () => void;
  handleStarClick: (e: MouseEvent, index: number) => void;
  strokeLinejoin: "miter" | "round";
  strokeLinecap: "butt" | "round";
  className?: string;
  isReadOnly: boolean;
  offset: number;
}

export default function Star({
  index,
  size,
  filledColor,
  emptyColor,
  innerRadius,
  outerRadius,
  handleStarMouseMove,
  handleMouseOut,
  handleStarClick,
  strokeLinejoin,
  strokeLinecap,
  className = "",
  isReadOnly,
  offset,
}: StarProps) {
  const center = Math.max(innerRadius, outerRadius);
  const angle = Math.PI / 5;
  const points = [];

  for (let i = 0; i < 5 * 2; i++) {
    let radius = i % 2 === 0 ? outerRadius : innerRadius;
    points.push(center + radius * Math.sin(i * angle));
    points.push(center - radius * Math.cos(i * angle));
  }

  const onMouseMove = (e: MouseEvent, index: number) => {
    handleStarMouseMove(e.nativeEvent.offsetX, index);
  };

  return (
    <svg
      style={{
        transition: "transform 0.1s ease-out",
        cursor: isReadOnly ? "default" : "pointer",
      }}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 100 100`}
      onMouseMove={(e) => onMouseMove(e, index)}
      onMouseOut={handleMouseOut}
      onClick={(e) => handleStarClick(e, index)}
    >
      <defs>
        <linearGradient id={`star-${index}`} x1="0" x2="100%" y1="0" y2="0">
          <stop offset={`0%`} stopColor={filledColor} />
          <stop offset={`${offset}%`} stopColor={filledColor} />
          <stop offset={`${offset}%`} stopColor={emptyColor} />
        </linearGradient>
      </defs>
      <path d={`M${points.toString()}Z`} fill={`url(#star-${index})`} strokeLinejoin={strokeLinejoin} strokeLinecap={strokeLinecap} />
    </svg>
  );
}
